import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import ImagesSection from '../CollapsibleSections/ImagesSection/ImagesSection';

import styles from '../styles.module.scss';
import { OralHealthReportSubmit } from '@brands/Dashboard/ConsultationPage/assets/types';
import { ICase } from '@brands/services/cases/types/ICase';
import { UserProfile } from '@brands/services/identity/types/UserProfile';
import { ImageWithNotes } from '@brands/services/forms/types/ImageWithNotes';
import { CASE_ATTACHMENT_ACCEPT } from '@brands/Utils/caseAttachmentFiles';

type Props = {
  consultationForm: OralHealthReportSubmit;
  setConsultationForm: React.Dispatch<React.SetStateAction<OralHealthReportSubmit>>;
  thisCase: ICase;
  setCase: React.Dispatch<React.SetStateAction<ICase>>;
  userInfo: UserProfile;
  setValue: any;
  errors: any;
  images: ImageWithNotes[];
  setImages: React.Dispatch<React.SetStateAction<ImageWithNotes[]>>;
  setEditImageNote: React.Dispatch<any>;
  setRemoveAttachment: React.Dispatch<any>;
  setRemoveImage: React.Dispatch<any>;
  updateSelectedImages: (updatedReport: any) => void;
  allowAttachmentUpdate: boolean;
  addPhoto: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checkCollapsibleHeaderColor: any;
};

const AttachmentsCard = ({
  consultationForm,
  setConsultationForm,
  thisCase,
  setCase,
  userInfo,
  setValue,
  errors,
  images,
  setImages,
  setEditImageNote,
  setRemoveAttachment,
  setRemoveImage,
  updateSelectedImages,
  allowAttachmentUpdate,
  addPhoto,
  checkCollapsibleHeaderColor,
}: Props): JSX.Element => {
  return (
    <div className={styles.consultationPageRightSideFrameCaseDetails}>
      <div className={styles.consultationPageRightSideFrameCaseDetailsTitle}>
        <div className={styles.consultationPageRightSideFrameCaseDetailsTitleDiv}>
          <span>Attachments</span>
          <Button
            className={styles.addPhotos}
            variant="text"
            component="label"
            startIcon={<AddIcon />}
            disabled={!allowAttachmentUpdate}
          >
            Add
            <input
              type="file"
              hidden
              multiple
              accept={CASE_ATTACHMENT_ACCEPT}
              onChange={addPhoto}
              disabled={!allowAttachmentUpdate}
            />
          </Button>
        </div>
      </div>

      <div
        className={`${styles.collapsibleContentImages} ${
          checkCollapsibleHeaderColor(thisCase || '', userInfo, 'EditImages') === 'editImages' ? styles.noCursor : ''
        }`}
      >
        <ImagesSection
          consultationForm={consultationForm}
          setConsultationForm={setConsultationForm}
          thisCase={thisCase}
          setCase={setCase}
          userInfo={userInfo}
          setValue={setValue}
          errors={errors}
          images={images}
          setImages={setImages}
          setEditImageNote={setEditImageNote}
          setRemoveAttachment={setRemoveAttachment}
          setRemoveImage={setRemoveImage}
          updateSelectedImages={updateSelectedImages}
          disabled={!allowAttachmentUpdate}
        />
      </div>
    </div>
  );
};

export default AttachmentsCard;
